import styled from '../../../../../../styles/styledComponents/themeComponents';

export const WidgetLayoutSelectStyle = styled.div`
  display: flex;
  gap: 5px;
  button {
    height: 40px;
    line-height: 40px;
  }
`;
